var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 63,
    viewBox: "0 0 70 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.099 37.5511C60.0953 34.7808 57.4642 32.9356 54.5177 32.9356H15.5204C12.675 32.9356 10.1307 34.7078 9.14435 37.3768L27.0698 54.7184L46.3148 47.8688L62.7216 42.0294L61.099 37.5511Z",
    fill: "#615C9F",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14435 37.3768L2.27263 55.9708C1.17059 58.9528 3.37687 62.1203 6.55598 62.1203L27.0698 54.7184L9.14435 37.3768Z",
    fill: "#615C9F",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0698 54.7184L6.55598 62.1203H53.5052L46.3148 47.8688L27.0698 54.7184Z",
    fill: "#615C9F",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0194 62.1203C64.8737 62.1203 68.2543 57.2997 66.6007 52.7357L62.7216 42.0294L46.3148 47.8688L53.5052 62.1203H60.0194Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1653 42.2338C41.4856 36.828 51.3388 23.7261 51.3388 16.3668C51.3388 7.44141 44.0963 0.200012 35.1694 0.200012C26.2426 0.200012 19 7.44141 19 16.3668C19 23.7261 28.8532 36.828 33.1735 42.2338C34.2094 43.5221 36.1295 43.5221 37.1653 42.2338ZM35.1694 10.9779C36.5989 10.9779 37.9698 11.5457 38.9806 12.5563C39.9914 13.5669 40.5592 14.9376 40.5592 16.3668C40.5592 17.7961 39.9914 19.1668 38.9806 20.1774C37.9698 21.188 36.5989 21.7558 35.1694 21.7558C33.74 21.7558 32.369 21.188 31.3583 20.1774C30.3475 19.1668 29.7796 17.7961 29.7796 16.3668C29.7796 14.9376 30.3475 13.5669 31.3583 12.5563C32.369 11.5457 33.74 10.9779 35.1694 10.9779Z",
    fill: "#615C9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/Area_icon.263617732d47686a54999949c8727d28.svg";
export { ForwardRef as ReactComponent };